// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.scrollable-date-picker {
  .non-selected-item-style {
    /* color: #bcbcbc; */
    font-family: 'Poppins';
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
      /* height : 50px; */
  } 

  .selected-item-style {
    /* color: #000; */
    font-family: 'Poppins';
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    /* height : 50px; */
  }
  
  .MuiButtonBase-root.MuiButton-root {
    & > div {
      & > div:last-child {
        border-radius: 10px;
  
        & > div {
          border: none;
          display: none;
        }
      }
    }
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/dateInput/scrollableDatePicker.css"],"names":[],"mappings":";;AAEA;EACE;IACE,oBAAoB;IACpB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;MACd,mBAAmB;EACvB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE;MACE;QACE,mBAAmB;;QAEnB;UACE,YAAY;UACZ,aAAa;QACf;MACF;IACF;EACF;AACF","sourcesContent":["\n\n.scrollable-date-picker {\n  .non-selected-item-style {\n    /* color: #bcbcbc; */\n    font-family: 'Poppins';\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 500;\n      /* height : 50px; */\n  } \n\n  .selected-item-style {\n    /* color: #000; */\n    font-family: 'Poppins';\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 500;\n    /* height : 50px; */\n  }\n  \n  .MuiButtonBase-root.MuiButton-root {\n    & > div {\n      & > div:last-child {\n        border-radius: 10px;\n  \n        & > div {\n          border: none;\n          display: none;\n        }\n      }\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
